import React, { useEffect } from 'react';
import {
  Button,
} from 'phoenix-components';
import confetti from 'canvas-confetti';
import PropTypes from 'prop-types';
import { useLanguageLoader } from 'contexts/language';
import styles from './ThankYou.module.css';
import { FooterButton } from 'components/common/FooterButton';
import { useIsDesktop } from 'contexts/profile';
import { Container } from 'components/layout/Container';
import StoreHeader from 'components/store/Header';
import { Divider } from '@mui/material';

function ThankYou({
  orderId, trackOrder, home, shop
}) {
  const lang = useLanguageLoader();
  const isDesktop = useIsDesktop();

  useEffect(() => {

    const duration = 30 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      spread: 360,
      ticks: 60,
      zIndex: 99999
    };
    function randomInRange(min, max) {

      return Math.random() * (max - min) + min;

    }

    const interval = setInterval(() => {

      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {

        return clearInterval(interval);

      }

      const particleCount = 50 * (timeLeft / duration);
      // since particles fall down, start a bit higher than random
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });

    }, 250);
    return () => {

      clearInterval(interval);

    };

  }, []);

  if (isDesktop) {
    return <div className={styles.container}>
      <Container>
        <StoreHeader
          onBack={history.back}
          shop={shop}
          showSearch
          showCart
        />
      </Container>
      <div className={styles.divider}>
        <Divider />
      </div>
      <Container>
        <div className={styles.bodyContainer}>
          <div className={styles.bodyHeader}>
            <div className={styles.orderConfirmedDesktop}>
              {lang('store.headings.orderConfirmed')}
            </div>
          </div>
          <div className={styles.body}>
            <img className={styles.trackIcon} src="/images/orders/success.svg" alt="" />
            <div className={styles.orderConfirmed}>
              {lang('store.headings.orderConfirmed')}
            </div>
            <div className={styles.orderId}>
              {`${lang('store.headings.orderId')} - ${orderId}`}
            </div>
            <div className={styles.thanksForOrder}>
              {lang('store.headings.thanksForOrder')}
            </div>
            <div className={styles.orderSuccess}>
              {lang('store.headings.orderSuccess')}
            </div>
            <div className={styles.buttons}>
              <Button
                label={lang('store.headings.trackOrder')}
                primary={false}
                className={styles.modalBtn}
                size="large"
                onClick={trackOrder}
              />
              <Button
                label={lang('store.form.home')}
                className={styles.modalBtn}
                size="large"
                onClick={home}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  }

  return (
    <div className={styles.container}>
      <div className={styles.header} />
      <div className={styles.body}>
        <img className={styles.trackIcon} src="/images/orders/success.svg" alt="" />
        <div className={styles.orderConfirmed}>
          {lang('store.headings.orderConfirmed')}
        </div>
        <div className={styles.orderId}>
          {`${lang('store.headings.orderId')} - ${orderId}`}
        </div>
        <div className={styles.thanksForOrder}>
          {lang('store.headings.thanksForOrder')}
        </div>
        <div className={styles.orderSuccess}>
          {lang('store.headings.orderSuccess')}
        </div>
      </div>
      <FooterButton>
        <div className={styles.buttons}>
          <Button
            fullWidth
            label={lang('store.headings.trackOrder')}
            primary={false}
            className={styles.modalBtn}
            size="large"
            onClick={trackOrder}
          />
          <Button
            fullWidth
            label={lang('store.headings.backToHome')}
            className={styles.modalBtn}
            size="large"
            onClick={home}
          />
        </div>
      </FooterButton>
    </div>
  );

}

ThankYou.propTypes = {
  orderId: PropTypes.string.isRequired,
  trackOrder: PropTypes.func.isRequired,
  home: PropTypes.func.isRequired,
  shop: PropTypes.object.isRequired,
};

export default ThankYou;
